import { ReactNode } from 'react';

import { Icon } from './icon';
import { Button } from './shadcn/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from './shadcn/dropdown-menu';

interface OverflowMenuProps {
  children: ReactNode;
  ariaLabel?: string;
  disabled?: boolean;
}

export function OverflowMenu({ children, ariaLabel = 'More actions', disabled = false }: OverflowMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="iconSm" aria-label={ariaLabel} disabled={disabled}>
          <Icon className="lucide--more-vertical" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">{children}</DropdownMenuContent>
    </DropdownMenu>
  );
}
